export default __webpack_public_path__ + "static/media/prometheus-svgrepo-com.52b810a6.svg";